export * from './add-edit-shelf-bin.component';
export * from './view-shelf-bin.component';